export const ALIGNMENTS = ['left', 'center'];
export const TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subheading', 'body'];
export const TAG_LABELS = {
  subheading: 'Subheading',
  body: 'Body'
};